import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "container-full-1 bg-grey-50" }
const _hoisted_2 = { class: "s20_mobile px-4" }
const _hoisted_3 = { class: "widget px-7 py-7" }
const _hoisted_4 = { class: "form-field-floating reactive active my-4" }
const _hoisted_5 = {
  key: 0,
  class: "text-red"
}
const _hoisted_6 = { class: "form-field-floating reactive active my-4" }
const _hoisted_7 = {
  key: 1,
  class: "text-red"
}
const _hoisted_8 = { class: "form-field-floating reactive active my-4" }
const _hoisted_9 = {
  key: 2,
  class: "text-red"
}
const _hoisted_10 = { class: "form-field-floating reactive active my-4" }
const _hoisted_11 = {
  key: 3,
  class: "text-red"
}
const _hoisted_12 = { class: "form-field-floating reactive active my-4" }
const _hoisted_13 = {
  key: 4,
  class: "text-red"
}
const _hoisted_14 = { class: "form-field-floating reactive active my-4" }
const _hoisted_15 = {
  key: 5,
  class: "text-red"
}
const _hoisted_16 = { class: "form-field-floating reactive active my-4" }
const _hoisted_17 = {
  key: 6,
  class: "text-red"
}
const _hoisted_18 = {
  key: 7,
  class: "text-red"
}
const _hoisted_19 = { class: "flex gap-2" }

import { inject, onMounted, reactive, ref, watch } from 'vue';
    import axios from 'axios';
    import { useRoute, useRouter } from 'vue-router';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'MarketFournisseursFormView',
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    const errorMessage = ref('');
    const loading = ref(false);
    const isFormValid = ref(false);
    const formData = reactive({
        id: "",
        nom_fournisseur: "",
        representant: "",
        adresse: "",
        telephone: "",
        email: "",
        ville: "",
        pays: ""
    });
    const errors = reactive({
        nom_fournisseur: "",
        representant: "",
        adresse: "",
        telephone: "",
        email: "",
        ville: "",
        pays: ""
    });

    onMounted(() => {
        const form_datas: any = route.meta.form_datas;
        if (form_datas?.fournisseur) {
            const item = form_datas.fournisseur as any;
            formData.id = item.id;
            formData.nom_fournisseur = item.nom_fournisseur;
            formData.representant = item.representant;
            formData.adresse = item.adresse;
            formData.telephone = item.telephone;
            formData.email = item.email;
            formData.ville = item.ville;
            formData.pays = item.pays;
        }
    });

    watch(formData, (oldFormData, newFormData) => {
        validate();
    });

    function validate() {
        let isValid = true;

        errors.nom_fournisseur = '';
        if (!formData.nom_fournisseur) {
            errors.nom_fournisseur ="Le nom du fournisseur est requis";
            isValid = false;
        }

        isFormValid.value = isValid;
        
        return isValid;
    }

    async function onSubmit() {
        if (!validate()) { return; }
        loading.value = true;
        errorMessage.value = '';
        try {
            const formToUpload = {
                id: formData.id,
                nom_fournisseur: formData.nom_fournisseur,
                representant: formData.representant,
                adresse: formData.adresse,
                telephone: formData.telephone,
                email: formData.email,
                ville: formData.ville,
                pays: formData.pays
            };

            await axios.post(`/backoffice/market-fournisseurs/save`, formToUpload);
            router.push('/app/market/market-fournisseurs/list');
        } catch(error: any) {
            errorMessage.value = error.message;
            console.error(error);
        } finally {
            loading.value = false;
        }
    }

return (_ctx: any,_cache: any) => {
  const _component_custom_button = _resolveComponent("custom-button")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "page-space-30" }, null, -1)),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[16] || (_cache[16] = _createElementVNode("h4", { class: "font-semibold mb-5" }, [
          _createTextVNode("Fournisseurs Market / Edition "),
          _createElementVNode("span", { class: "text-sm text-grey-500" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.nom_fournisseur) = $event)),
            name: "nom_fournisseur",
            id: "nom_fournisseur",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.nom_fournisseur]
          ]),
          _cache[8] || (_cache[8] = _createElementVNode("label", { for: "nom_fournisseur" }, [
            _createTextVNode("Nom fournisseur "),
            _createElementVNode("b", { class: "color-danger" }, "*")
          ], -1))
        ]),
        (!!errors['nom_fournisseur'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(errors['nom_fournisseur']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.representant) = $event)),
            name: "representant",
            id: "representant",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.representant]
          ]),
          _cache[9] || (_cache[9] = _createElementVNode("label", { for: "representant" }, "Nom & prénoms représentant", -1))
        ]),
        (!!errors['representant'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(errors['representant']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-input",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.adresse) = $event)),
            name: "adresse",
            id: "adresse",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.adresse]
          ]),
          _cache[10] || (_cache[10] = _createElementVNode("label", { for: "adresse" }, "Adresse", -1))
        ]),
        (!!errors['adresse'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(errors['adresse']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_10, [
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.telephone) = $event)),
            name: "telephone",
            id: "telephone",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.telephone]
          ]),
          _cache[11] || (_cache[11] = _createElementVNode("label", { for: "telephone" }, "Téléphone", -1))
        ]),
        (!!errors['telephone'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(errors['telephone']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _withDirectives(_createElementVNode("input", {
            type: "email",
            class: "form-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.email) = $event)),
            name: "email",
            id: "email",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.email]
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("label", { for: "email" }, "Adresse email", -1))
        ]),
        (!!errors['email'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(errors['email']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_14, [
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-input",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.pays) = $event)),
            name: "pays",
            id: "pays",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.pays]
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("label", { for: "pays" }, "Pays", -1))
        ]),
        (!!errors['pays'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(errors['pays']), 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_16, [
          _withDirectives(_createElementVNode("input", {
            type: "tel",
            class: "form-input",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.ville) = $event)),
            name: "ville",
            id: "ville",
            placeholder: "",
            autocomplete: "off"
          }, null, 512), [
            [_vModelText, formData.ville]
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("label", { for: "ville" }, "Ville", -1))
        ]),
        (!!errors['ville'])
          ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(errors['ville']), 1))
          : _createCommentVNode("", true),
        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "clear-both h-30" }, null, -1)),
        (!!errorMessage.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(errorMessage.value), 1))
          : _createCommentVNode("", true),
        _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-text-xs text-grey-500 mb-5" }, [
          _createElementVNode("b", { class: "color-danger text-xs" }, "*"),
          _createTextVNode(" Les champs marqués d'un astérisque sont obligatoires")
        ], -1)),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_custom_button, {
            id: "btn-submit",
            type: "button",
            classesList: 'btn lg w-100',
            loading: loading.value,
            onClick: _cache[7] || (_cache[7] = ($event: any) => (onSubmit()))
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
              _createElementVNode("img", {
                src: "/icons/icon-enregistrer.svg",
                class: "btn-icon",
                alt: ""
              }, null, -1),
              _createElementVNode("span", null, "Enregistrer", -1)
            ]))]),
            _: 1
          }, 8, ["loading"])
        ])
      ])
    ])
  ]))
}
}

})